import { render, staticRenderFns } from "./g-drag-image.vue?vue&type=template&id=a9f15354&"
import script from "./g-drag-image.vue?vue&type=script&setup=true&lang=ts&"
export * from "./g-drag-image.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports